import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.3992 13L2.59922 13L2.59922 11.7L10.3992 11.7L10.3992 13ZM11.6992 10.4L1.29922 10.4L1.29922 9.1L11.6992 9.1L11.6992 10.4Z",
      fill: "#AA1E2D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.7 1.3V6.5H1.3V1.3H11.7ZM11.7 0H1.3C0.955218 0 0.624558 0.136964 0.380761 0.380761C0.136964 0.624559 0 0.955218 0 1.3V6.5C0 6.84478 0.136964 7.17544 0.380761 7.41924C0.624558 7.66304 0.955218 7.8 1.3 7.8H11.7C12.0448 7.8 12.3754 7.66304 12.6192 7.41924C12.863 7.17544 13 6.84478 13 6.5V1.3C13 0.955218 12.863 0.624559 12.6192 0.380761C12.3754 0.136964 12.0448 0 11.7 0Z",
      fill: "#AA1E2D"
    }, null, -1)
  ])))
}
export default { render: render }